import { GameWorld, eGameObject as eWorldObject } from "../../../GameWorld";
import { RoadBase } from "./Road";
import { eType } from "../../Section";


export class Road2 extends RoadBase {
    private static readonly SIZE = 2;

    private static _1ST_ENTITY: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("road2", eType.road2, 2);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let e = GameWorld.instance.getObjectNewEntity(eWorldObject.road);
        e.setPosition(0, 0, 0);
        e.setLocalScale(1, 1, 1);
        e.reparent(this._root);
    }
}